module.exports = __webpack_public_path__ + "img/monri.d75f7e3a.png";